import React from 'react';
import { saveAs } from 'file-saver';
// import XLSX from 'XLSX';
import Workbook from 'composer/tools/Workbook.js';

import autoBind from 'react-autobind';
import { If, Then, Else } from 'react-if'
import Switch, { Case } from 'react-switch-case';

import Localization from "composer/Localization.jsx"

import RootPage from "composer/pages/RootPage.jsx"
import RetrieverBar from "composer/views/retriever/RetrieverBar.jsx"
import SubmissionDetail from "composer/views/retriever/SubmissionDetail.jsx"
import SubmissionDetailMapDialog from "composer/views/retriever/SubmissionDetailMapDialog.jsx"
import {  IconButton, Tooltip, Button } from '@material-ui/core';
import ShareIcon from '@material-ui/icons/Share';
import ArchiveIcon from '@material-ui/icons/Archive';
import {
  grey,
} from '@material-ui/core/colors'
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Icon,
  Card,
  CardContent,
  Grid,
  Divider,
  Typography,
  ListItemSecondaryAction,
} from '@material-ui/core';
import Config from '../Config';

const
    XLSX = require('xlsx');

const RET_VIEW_DATES = 0;
const RET_VIEW_SUBMISSION_GROUPS = 1;
const RET_VIEW_SUBMISSION_HISTORY = 2;

class RetrieverPage extends React.Component {
  static RET_VIEW_DATES() {
    return RET_VIEW_DATES;
  }

  static RET_VIEW_SUBMISSION_GROUPS() {
    return RET_VIEW_SUBMISSION_GROUPS;
  }

  static RET_VIEW_SUBMISSION_HISTORY() {
    return RET_VIEW_SUBMISSION_HISTORY;
  }

  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      status: RET_VIEW_DATES,
      currentLocaleId: this.props.localeData.id,
      currentDate: "",
      submissionGroupList: [],
      submissionList: [],
      maxHeight: 0,
      selectedIndex: -1,
    };
    autoBind(this);

    this.refresh();
  }

  componentDidMount() {
    console.log('RetrieverPage rendered');
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  initWindowDimensions() {

  }

  updateWindowDimensions() {
    let boundingRect = this.refs.retrieverBar.refs.div.getBoundingClientRect();
    // let boundingRect = this.props.root.refs.topBar.getBoundingClientRect();
    // console.log('bounding rect: ', boundingRect);
    // console.log(this.props.root.refs.topBar.refs.div.getBoundingClientRect());
    let height = window.innerHeight - (boundingRect.y + window.scrollY + boundingRect.height);
    // let height = window.innerHeight - (64 + window.scrollY + 56.5);

    if(height <= 0){
      height = window.innerHeight - (64 + window.scrollY + 56.5);
    }

    this.setState({
      maxHeight: height,
    });
    this.state.maxHeight = height;
  }

  refresh() {
    console.log('school id:', this.props.root.getMySchoolId(), 'locale id:', this.state.currentLocaleId);
    switch(this.state.status) {
      case RET_VIEW_DATES:
        console.log("get_submission_groups_by_epack");
        this.props.root.refs.API.request("get_submission_groups_by_epack", { school_id: this.props.root.getMySchoolId(), locale_id: this.state.currentLocaleId }, this.getSubmissionGroupByLocaleOK, this.getSubmissionGroupByLocaleFailed);
        break;
      case RET_VIEW_SUBMISSION_GROUPS:
        console.log("get_submission_list_by_epack_and_date");
        // console.log('send get_submission_list_by_epack_and_date req:', { school_id: this.props.root.getMySchoolId(), locale_id: this.state.currentLocaleId, date:this.state.currentDate });
        this.props.root.refs.API.request("get_submission_list_by_epack_and_date", { school_id: this.props.root.getMySchoolId(), locale_id: this.state.currentLocaleId, date:this.state.currentDate }, this.getSubmissionGroupByDateOK, this.getSubmissionGroupByDateFailed);
        break;
      default:
        break;
    }
  }

  getSubmissionGroupByLocaleOK(res) {
    this.setState({submissionGroupList: res.body['result']});
  }

  getSubmissionGroupByLocaleFailed(err) {
    console.log("get submission group by locale failed");
  }

  getSubmissionGroupByDateOK(res) {
    this.setState({submissionList:res.body['result']});
    this.updateWindowDimensions();
  }

  getSubmissionGroupByDateFailed(err) {
    console.log("get submission group by date failed");
  }

  handleDateClicked(date, changeHistory=true) {
    this.setState({
      status: RET_VIEW_SUBMISSION_GROUPS,
      currentDate: date,
      selectedIndex: -1,
    });
    this.state.status = RET_VIEW_SUBMISSION_GROUPS;
    this.state.currentDate = date;
    this.state.selectedIndex = -1;
    this.refresh();

    if (changeHistory) {
      this.props.root.pushHistory("retriever/date");
    }
  }

  handleSubmissionClicked(index, submission_id, user_name) {
    // console.log('submission list:', this.state.submissionList);
    this.setState({
      currentSubmissionId: submission_id,
      currentUsername:user_name,
      selectedIndex: index,
    });
    this.state.currentSubmissionId = submission_id;
    this.state.currentUsername = user_name;
    this.state.selectedIndex = index;
    this.refreshSubmissionDetail(submission_id);
  }

  refreshSubmissionDetail(id) {
    this.refs.submissionDetail.setState({ submissionId: id });
    this.refs.submissionDetail.state.submissionId = id;
    this.refs.submissionDetail.refresh();

    this.refs.retrieverBar.setState({ userOption: id });
  }

  handleBackButtonClicked() {
    console.log('handleBackButtonClicked');
    if (this.state.status == RET_VIEW_DATES) {
      this.props.root.changeStatus(this.props.parent.STATUS_VIEW_LOCALE())
    }
    else if (this.state.status == RET_VIEW_SUBMISSION_GROUPS) {
      this.setState({
        status: RET_VIEW_DATES,
      })
      this.state.status = RET_VIEW_DATES;
      this.refs.submissionDetail.setState({ hotspotList: [] });
      this.refs.retrieverBar.setState({ submissionList: [] });
    }
    else if (this.state.status == RET_VIEW_SUBMISSION_HISTORY) {
      this.setState({
        status: RET_VIEW_SUBMISSION_GROUPS,
      })
      this.state.status = RET_VIEW_SUBMISSION_GROUPS;
      this.refs.submissionDetail.setState({ hotspotList: [] });
    }
  }

  handleForwardButtonClicked() {
    if (this.state.status == RET_VIEW_DATES) {
      this.handleDateClicked(this.state.currentDate, false);
    }
  }

  handleRouteClicked() {
    this.refs.submissionDetailMapDialog.setState({ open: true });
  }

  tidy_ans_batch(answers){
    let result = [];
    let component_data = [];
    answers = JSON.parse(answers).result;
    // console.log('answer:', answers);

    for(let i = 0; i < answers.submission_list.length; i++){
      var udid = answers.submission_list[i].submission_data.udid;
      var username = answers.submission_list[i].submission_data.user_name;
      var submission_id = answers.submission_list[i].submission_data.id;
      for(let j = 0; j < answers.submission_list[i].hotspot_list.length; j++){
        var hotspot_id = answers.submission_list[i].hotspot_list[j].hotspot_detail.id;
        var hotspot_name = answers.submission_list[i].hotspot_list[j].hotspot_detail.name;
        // console.log(answers.submission_list[i].hotspot_list[j]);
        for(let k = 0; k < answers.submission_list[i].hotspot_list[j].answer_list.length; k++){
          var component_id = answers.submission_list[i].hotspot_list[j].answer_list[k].component_id;
          var component_kind_id = answers.submission_list[i].hotspot_list[j].answer_list[k].kind;
          var component_kind = Config.GET_HOTSPOT_CONTENT_CONFIG(parseInt(component_kind_id)).title;
          var answer = answers.submission_list[i].hotspot_list[j].answer_list[k].answer;
          if((component_kind_id == '11' || component_kind_id == '13') && answers.submission_list[i].hotspot_list[j].answer_list[k].path != ''){
            answer = Config.UPLOAD_PATH() + answers.submission_list[i].hotspot_list[j].answer_list[k].path;
          }
          var component_name = '';
          var component_content = '';
          result.push({udid:udid, username:username, submission_id:submission_id, hotspot_id:hotspot_id, hotspot_name:hotspot_name, component_id:component_id, component_kind_id:component_kind_id, component_kind:component_kind, component_name:component_name, component_content:component_content, answer:answer});
        }

        for(let k = 0; k < answers.submission_list[i].hotspot_list[j].hotspot_detail.component_list.length; k++){
          var component_id = answers.submission_list[i].hotspot_list[j].hotspot_detail.component_list[k].id;
          var component_name = answers.submission_list[i].hotspot_list[j].hotspot_detail.component_list[k].name;
          var component_content = answers.submission_list[i].hotspot_list[j].hotspot_detail.component_list[k].content;

          component_data.push({component_id:component_id, component_name:component_name, component_content:component_content});
        }
      }
    }

    //merge result and conponent_data
    for(let i = 0; i < result.length; i++){
      for(let j = 0; j < component_data.length; j++){
        if(result[i].component_id == component_data[j].component_id){
          //component id matched
          result[i].component_name = component_data[j].component_name;
          result[i].component_content = component_data[j].component_content;
        }
      }
    }

    return result;
  }

  download_ans_batch_OK(res, filename){
    // var file = new File([this.tidy_ans_batch(res.text)], filename, {type: "text/plain;charset=utf-8"});
    const workbook = new Workbook();
    const data = this.tidy_ans_batch(res);
    const sheet = XLSX.utils.json_to_sheet(data);
    workbook.appendSheet(sheet, 'Latest_Submission');
    saveAs(workbook.toBlob(), filename);
  }

  download_ans_batch_fail(err){
    console.log("download ans batch failed");
  }

  download_ans_batch(filename='test.csv', currentDate) {
    let submissionList = [];
    this.props.root.refs.API.request("get_submission_list_by_epack_and_date", { school_id: this.props.root.getMySchoolId(), locale_id: this.state.currentLocaleId, date:currentDate },
      (res)=>{
        submissionList = res.body['result'];
        let submissionIDList = [];
        for (let i = 0; i < submissionList.length; i++) {
          submissionIDList.push(submissionList[i].id);
        }
        this.props.root.refs.API.request_ans("download_ans_batch", filename, { school_id: this.props.root.getMySchoolId(), locale_id: this.state.currentLocaleId, date:currentDate, submission_id_list:submissionIDList}, this.download_ans_batch_OK, this.download_ans_batch_fail);
      },
      ()=>{
        console.log('retrieve submission_list_by_epack_and_date failed');
      }
    );
  }

  tidy_ans(answers){
    let result = [];
    let component_data = [];
    answers = JSON.parse(answers).result;
    console.log('answer:', answers);
  
    var udid = answers.submission_data.udid;
    var username = answers.submission_data.user_name;
    var submission_id = answers.submission_data.id;
    for(let j = 0; j < answers.hotspot_list.length; j++){
      var hotspot_id = answers.hotspot_list[j].hotspot_detail.id;
      var hotspot_name = answers.hotspot_list[j].hotspot_detail.name;
      for(let k = 0; k < answers.hotspot_list[j].answer_list.length; k++){
        var component_id = answers.hotspot_list[j].answer_list[k].component_id;
        var component_kind_id = answers.hotspot_list[j].hotspot_detail.component_list[k].kind;
        var component_kind = Config.GET_HOTSPOT_CONTENT_CONFIG(parseInt(component_kind_id)).title;
        var answer = answers.hotspot_list[j].answer_list[k].answer;
        if((component_kind_id == '11' || component_kind_id == '13') && answers.hotspot_list[j].answer_list[k].path != ''){
          answer = Config.UPLOAD_PATH() + answers.hotspot_list[j].answer_list[k].path;
        }
        var component_name = '';
        var component_content = '';
        result.push({udid:udid, username:username, submission_id:submission_id, hotspot_id:hotspot_id, hotspot_name:hotspot_name, component_id:component_id, component_kind_id:component_kind_id, component_kind:component_kind, component_name:component_name, component_content:component_content, answer:answer});
      }

      for(let k = 0; k < answers.hotspot_list[j].hotspot_detail.component_list.length; k++){
        var component_id = answers.hotspot_list[j].hotspot_detail.component_list[k].id;
        var component_name = answers.hotspot_list[j].hotspot_detail.component_list[k].name;
        var component_content = answers.hotspot_list[j].hotspot_detail.component_list[k].content;

        component_data.push({component_id:component_id, component_name:component_name, component_content:component_content});
      }
    }

    //merge result and conponent_data
    for(let i = 0; i < result.length; i++){
      for(let j = 0; j < component_data.length; j++){
        if(result[i].component_id == component_data[j].component_id){
          //component id matched
          result[i].component_name = component_data[j].component_name;
          result[i].component_content = component_data[j].component_content;
        }
      }
    }

    return result;
  }

  download_ans_OK(res, filename){
    // console.log('download ans ok:', res);
    const workbook = new Workbook();
    const data = this.tidy_ans(res);
    const sheet = XLSX.utils.json_to_sheet(data);
    workbook.appendSheet(sheet, 'Latest_Submission');
    saveAs(workbook.toBlob(), filename);
  }

  download_ans_fail(err){
    console.log('download ans failed');
  }

  download_ans(filename='test.csv', submission_id){
    this.props.root.refs.API.request_ans("download_ans", filename, {submission_id:submission_id}, this.download_ans_OK, this.download_ans_fail);
  }

  render() {
        //If the description is too long, break down the word
    let paragraph = "";
    for (var i=0;i<this.props.localeData['name'].length;i++){
    if(i%40 == 0 && window.screen.width >= 1024){
      paragraph = paragraph + "\n" ;
    }

    if(i%10 == 0 && window.screen.width < 1024){
      paragraph = paragraph + "\n" ;
      }
      paragraph = paragraph + this.props.localeData['name'][i];
    }
        //
        
    return (
      <div>
        <SubmissionDetailMapDialog root={this.props.root} parent={this} ref="submissionDetailMapDialog"/>
        <RetrieverBar root={this.props.root} parent={this} ref="retrieverBar"/>
        <Grid container>
          <Grid item xs={8} sm={3}>
            <Switch condition={this.state.status}>
              <Case value={RET_VIEW_DATES}>
                <List style={{maxHeight:this.state.maxHeight, overflow:'auto', padding:'0'}}>
                  <ListItem>
                    <ListItemText>
                      <Typography variant="h6">{paragraph}</Typography>
                    </ListItemText>
                  </ListItem>
                  <Divider variant="middle" />
                  <If condition={this.state.submissionGroupList.length == 0}>
                    <Then>
                      <Card style={{margin: "10px",bottom:'10px'}}>
                        <CardContent>
                          {Localization.strings.EMPTY_SUBMISSION_REMINDER}
                        </CardContent>
                      </Card>
                    </Then>
                    <Else>
                      {this.state.submissionGroupList.map( (row, i) => {
                        return (
                          <div>
                          <ListItem button key={i} style={{border:"2px solid #9e9e9e",margin:"5px 2px 5px 2px",width:"92%",left:'3.5%'}}
                          onClick={()=>this.handleDateClicked(row['submission_time'])}>
                            <ListItemIcon>
                              <Icon>today</Icon>
                            </ListItemIcon>
                            <ListItemText
                              primary={row['submission_time'].split(" ")[0]}
                              secondary={Localization.strings.SUBMISSION_S + ": " + row['count'] + '    '
                                + Localization.strings.SUBMISSION_P + ": " + row['count_u']}
                            />
                            <ListItemSecondaryAction>
                              <Tooltip title={Localization.strings.ARCHIVE}>
                                <IconButton onClick={()=>this.download_ans_batch(this.props.localeData['name'] + '_' + row['submission_time'] + '.xlsx', row['submission_time'])} >
                                  <Icon style={{ color: grey[600] }}>archive</Icon>
                                </IconButton>
                              </Tooltip>
                              {/*
                              <Tooltip title={Localization.strings.SHARE}>
                                <IconButton>
                                  <Icon style={{ color: grey[600] }}>share</Icon>
                                </IconButton>
                              </Tooltip>
                              */}
                            </ListItemSecondaryAction>
                          </ListItem>
                          {/*
                          <Card variant="outlined" className="margin-std padding-sm" >
                            <CardContent className="padding-zero">
                              <ListItem button key={i} onClick={()=>this.handleDateClicked(row['submission_time'])}>
                                <ListItemIcon>
                                  <Icon>today</Icon>
                                </ListItemIcon>
                                <ListItemText
                                  primary={row['submission_time'].split(" ")[0]}
                                  secondary={Localization.strings.SUBMISSION_S + ": " + row['count']}
                                />
                                <ListItemSecondaryAction>
                                  <Tooltip title={Localization.strings.DOWNLOAD}>
                                    <IconButton
                                      onClick={()=>this.download_ans_batch(this.props.localeData['name'] + '_' + row['submission_time'] + '.csv')}
                                    >
                                      <Icon style={{ color: grey[200] }}>download</Icon>
                                    </IconButton>
                                  </Tooltip>
                                </ListItemSecondaryAction>
                              </ListItem>
                            </CardContent>
                          </Card>
                          */}
                          </div>
                        );
                      })}
                    </Else>
                  </If>
                </List>
              </Case>
              <Case value={RET_VIEW_SUBMISSION_GROUPS}>
                <List style={{maxHeight:this.state.maxHeight, overflow:'auto', padding:'0'}}>
                  <ListItem>
                    <ListItemText>
                      <Typography variant="h6">{this.state.currentDate.split(" ")[0]}</Typography>
                    </ListItemText>
                  </ListItem>
                  <Divider variant="middle"/>
                  {this.state.submissionList.map( (row, i) => {
                    return (
                      <ListItem style={{border:"2px solid #9e9e9e",margin:"5px 2px 5px 2px",width:"92%",left:'3.5%'}}
                        button
                        key={i}
                        onClick={()=>this.handleSubmissionClicked(i ,row['id'], row['user_name'])}
                        selected={i == this.state.selectedIndex}
                      >
                        <ListItemIcon>
                          <Icon>face</Icon>
                        </ListItemIcon>
                        
                        <ListItemText 
                          primary={row['user_name']}
                          secondary={Localization.strings.LATEST_SUBMISSION + ": " + row['submission_time'].split(" ")[1] + ' ' +
                            Localization.strings.SUBMISSION_S + ": " + row['sub_c']}
                        />
                        {/* <ListItemSecondaryAction>
                          <Tooltip title={Localization.strings.ARCHIVE}>
                            <IconButton onClick={()=>this.download_ans(this.props.localeData['name'] + '_' + row['user_name'] + '_' + row['submission_time'] + '.xlsx', this.refs.submissionDetail.state.submissionId == 0?row['id']:this.refs.submissionDetail.state.submissionId)} >
                              <Icon style={{ color: grey[600] }}>archive</Icon>
                            </IconButton>
                          </Tooltip>
                          <Tooltip title={Localization.strings.SHARE}>
                            <IconButton>
                              <Icon style={{ color: grey[600] }}>share</Icon>
                            </IconButton>
                          </Tooltip>
                        </ListItemSecondaryAction> */}
                      </ListItem>
                    );
                  })}
                </List>
              </Case>
            </Switch>
          </Grid>
          <Grid item xs={8} sm={9}>
            <SubmissionDetail root={this.props.root} parent={this} ref="submissionDetail"
              maxHeight={this.state.maxHeight}
            />
          </Grid>
        </Grid>
      </div>
    )
  }
}

export default RetrieverPage;
